import { useEffect, useRef, useState } from 'react';
import { Appearance, AppState, ColorSchemeName } from 'react-native';

export const COLOR_SCHEME_RESUME_SUPPRESS_MS = 500;

export const useStableColorScheme = (): ColorSchemeName => {
  const [scheme, setScheme] = useState<ColorSchemeName>(() => Appearance.getColorScheme());
  const resumedAtRef = useRef(0);

  useEffect(() => {
    const appStateSub = AppState.addEventListener('change', (state) => {
      if (state !== 'active') return;
      resumedAtRef.current = Date.now();
      setTimeout(() => setScheme(Appearance.getColorScheme()), COLOR_SCHEME_RESUME_SUPPRESS_MS);
    });

    const appearanceSub = Appearance.addChangeListener(({ colorScheme }) => {
      if (AppState.currentState !== 'active') return;
      if (Date.now() - resumedAtRef.current < COLOR_SCHEME_RESUME_SUPPRESS_MS) return;
      setScheme(colorScheme);
    });

    return () => {
      appStateSub.remove();
      appearanceSub.remove();
    };
  }, []);

  return scheme;
};
